import type { DecisionDTO } from "@roomate/core";

/**
 * Which decision the Inbox shows. `selectedId` comes from the list (j/k, a click) or from a
 * `?decision=` link. A linked decision that is no longer open is not in the open list, so it is
 * taken from the fetched decision instead. Until that fetch lands, `linkedPending` is true and the
 * caller shows a loading state, never another decision.
 */
export function pickDecision(list: DecisionDTO[], selectedId: string | null, fetched: DecisionDTO | undefined, projectFilter: string | null = null): { decision: DecisionDTO | null; linkedPending: boolean } {
  if (!selectedId) return { decision: list[0] ?? null, linkedPending: false };
  const inList = list.find((d) => d.id === selectedId);
  if (inList) return { decision: inList, linkedPending: false };
  if (fetched?.id === selectedId) {
    // A deep link into another project than the active filter is ignored: the filtered queue shows instead.
    if (projectFilter && fetched.projectId !== projectFilter) return { decision: list[0] ?? null, linkedPending: false };
    return { decision: fetched, linkedPending: false };
  }
  return { decision: null, linkedPending: true };
}
